module.exports = __webpack_public_path__ + "media/images/lb/760-0662e78c85f45a4af584a8fd7fbc6683.svg";